// this acts as a replacement for cogsworthAppointments.ts, with improved error handling

import axios from 'axios';

import { getAuthToken } from '@providers/AuthProvider';
import { ApiEndpoints } from '@utils/endpoints';
import { datadogRum } from '@datadog/browser-rum';

export const confirmAppointment = async (appointmentId: string): Promise<boolean> => {
	const authorizationToken = await getAuthToken();
	const response = await axios
		.post<{ appointmentConfirmed: boolean }>(
			`${ApiEndpoints.cogsworthConfirmAppointment}/${appointmentId}`,
			{},
			{
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					authorizationToken,
				},
			}
		)
		.catch((error: unknown) => {
			datadogRum.addError(`Error confirming appointment ${appointmentId}: ${error}`);
			throw new Error(`Error confirming appointment ${appointmentId}`, { cause: error });
		});
	return response.data.appointmentConfirmed;
};
